import { cva } from 'class-variance-authority';

const rowClass = cva('row', {
    variants: {
        justify: {
            start: ['justify-start'],
            center: ['justify-center'],
            end: ['justify-end'],
            between: ['justify-between'],
            around: ['justify-around'],
        },
        items: {
            start: ['items-start'],
            center: ['items-center'],
            end: ['items-end'],
        },
    },
    defaultVariants: {},
});

const colClass = cva('col', {
    variants: {
        base: {
            '1/2': ['w-1/2'],
            '4/12': ['w-4/12'],
            '6/12': ['w-6/12'],
            '8/12': ['w-8/12'],
            '10/12': ['w-10/12'],
            auto: ['w-auto'],
            '1/5': ['w-1/5'],
        },
        sm: {
            '1/2': ['sm:w-1/2'],
            '4/12': ['sm:w-4/12'],
            '6/12': ['sm:w-6/12'],
            '8/12': ['sm:w-8/12'],
            '10/12': ['sm:w-10/12'],
            auto: ['sm:w-auto'],
            '1/5': ['sm:w-1/5'],
        },
        md: {
            '1/2': ['md:w-1/2'],
            '3/12': ['md:w-3/12'],
            '4/12': ['md:w-4/12'],
            '6/12': ['md:w-6/12'],
            '8/12': ['md:w-8/12'],
            '10/12': ['md:w-10/12'],
            auto: ['md:w-auto'],
            '1/5': ['md:w-1/5'],
        },
        lg: {
            '1/2': ['lg:w-1/2'],
            '3/12': ['lg:w-3/12'],
            '4/12': ['lg:w-4/12'],
            '6/12': ['lg:w-6/12'],
            '8/12': ['lg:w-8/12'],
            '10/12': ['lg:w-10/12'],
            auto: ['lg:w-auto'],
            '1/5': ['lg:w-1/5'],
        },
        xl: {
            '1/2': ['xl:w-1/2'],
            '4/12': ['xl:w-4/12'],
            '6/12': ['xl:w-6/12'],
            '8/12': ['xl:w-8/12'],
            '10/12': ['xl:w-10/12'],
            auto: ['xl:w-auto'],
            '1/5': ['xl:w-1/5'],
        },
    },
    defaultVariants: {},
});

export const Row = ({ children, ...props }) => {
    const { justify, items } = props;

    return <div className={rowClass({ justify, items })}>{children}</div>;
};
export const Col = ({ children, ...props }) => {
    const { base, sm, md, lg, xl } = props;

    return <div className={colClass({ base, sm, md, lg, xl })}>{children}</div>;
};
